import { SET_JOBAPPLICATIONS, CLEAR_JOBAPPLICATIONS } from "../actions/types";

const applications = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_JOBAPPLICATIONS:
      return payload;
    case CLEAR_JOBAPPLICATIONS:
        return null;
    default:
      return state;
  }
};

export default applications;
